
;( function( $, window, document, undefined ) {

	"use strict";

		// Create the defaults once
		var pluginName = "editable",
			defaults = {
                'key' : null,
                'placeholder' : "Add content...",
				'label' : "",
                'newLineOnEnterKey' : false,
                'onFocus' : false,
                'onBlur' : false,
                'onSave' : false
			};

		// The actual plugin constructor
		function Plugin ( element, options ) {
			this.element = element;
			this.settings = $.extend( {}, defaults, options );
			this._defaults = defaults;
			this._name = pluginName;
			this.init();
		}

		// Avoid Plugin.prototype conflicts
		$.extend( Plugin.prototype, {
			init: function() {
				// Place initialization logic here
				// access to the DOM element and the options via the instance, e.g. this.element and this.settings
                var oThis = this;
                var $this = $(this.element);
                $this.attr("contenteditable","true");
                this.content = this.updateContent(this.element);
                if(this.content == ''){ $this.html(oThis.settings.placeholder); }
                if(this.settings.key == null) { this.settings.key = "storage" + generateUUID(); }
				$this.attr("data-label",this.settings.label);
                $this.on('focus',function(){
                    oThis.handleFocus();
                });
                $this.on('blur',function(){
                    oThis.handleBlur();
                });
			},

            updateContent: function(element) {
                var content = $(element).html();
                if($.trim($(element).text()) == ''){ content = ''; }
                return content;
			},

            handleFocus: function(){
                var oThis = this;
                var $this = $(this.element);
                this.content = this.updateContent(this.element);
                /*if(this.content == this.settings.placeholder){
                    $this.empty();
                    var range = document.createRange();
                    range.selectNodeContents(this);
                    var sel = window.getSelection();
                    sel.removeAllRanges();
                    sel.addRange(range);
                }*/
                if(this.settings.newLineOnEnterKey == false){
                    $this.keypress(function(e){
                        var keycode = (e.keyCode ? e.keyCode : e.which);
                        if(keycode == '13') {
                            e.preventDefault();
                            $this.blur();
                        }
                    });
                }

                $this.addClass("is-editing");
			    this.cache();
                $this.keydown(function(e){
                    if (e.keyCode == 27) { oThis.cancelEdit(); }   // esc
                    if (e.keyCode != 27) { $this.addClass("is-edited"); }
                });

                if($.isFunction(this.settings.onFocus)){ this.settings.onFocus(this); }
            },

            handleBlur: function(){
                var oThis = this;
                var $this = $(this.element);

                if( $this.hasClass("is-cancelled") ) {
			    	//if user escaped, we don't save, just revert the classes
			    	$this.removeClass("is-cancelled is-editing");
			    } else if( $this.hasClass("is-edited") ) {
			    	//if user changed anything
			    	$this.removeClass("is-editing is-edited");
			    	oThis.save();
			    }

                if($.isFunction(this.settings.onBlur)){ this.settings.onBlur(this); }
            },

            save: function(){
                this.content = this.updateContent(this.element);
                if($.isFunction(this.settings.onSave)){ this.settings.onSave(this); }
            },

            cache: function(){
                sessionStorage[this.settings.key] = this.content;
            },

            cancelEdit: function(){
                var oThis = this;
                var $this = $(this.element);
                $this.html( sessionStorage[oThis.settings.key] ).addClass("is-cancelled").trigger("blur");
            },

            revert: function(){
                var oThis = this;
                var $this = $(this.element);
                $this.html( sessionStorage[oThis.settings.key] );
            }

		} );

		// A really lightweight plugin wrapper around the constructor,
		// preventing against multiple instantiations
		$.fn[ pluginName ] = function( options ) {
			return this.each( function() {
				if ( !$.data( this, "plugin_" + pluginName ) ) {
					$.data( this, "plugin_" +
						pluginName, new Plugin( this, options ) );
				}
			} );
		};

} )( jQuery, window, document );
